export const SIGN_UP_MODAL = 'SIGN_UP_MODAL';
export const LOGIN_MODAL = 'LOGIN_MODAL';
export const SOCIAL_MODAL = 'SOCIAL_MODAL';
export const MOBILE_SOCIAL_MODAL = 'MOBILE_SOCIAL_MODAL';
export const EDIT_ABOUT_MODAL = 'EDIT_ABOUT_MODAL';
export const SEND_TICKETS_MODAL = 'SEND_TICKETS_MODAL';
export const END_POOL_MODAL = 'END_POOL_MODAL';
export const END_POOL_CONFIRM_MODAL = 'END_POOL_CONFIRM_MODAL';
export const JOIN_POOL_MODAL = 'JOIN_POOL_MODAL';
export const PARTICIPATION_MODAL = 'PARTICIPATION_MODAL';
export const REDEEM_MODAL = 'REDEEM_MODAL';
export const EDIT_TOKENS_MODAL = 'EDIT_TOKENS_MODAL';
export const MANUAL_ORDERS_MODAL = 'MANUAL_ORDERS_MODAL';
export const REVIEW_EDIT_TOKENS_MODAL = 'REVIEW_EDIT_TOKENS_MODAL';
export const CREATE_HPOOL_SIGN_TX_MODAL = 'CREATE_HPOOL_SIGN_TX_MODAL';
export const USER_REDEEM_HPOOL_TOKENS_MODAL = 'USER_REDEEM_HPOOL_TOKENS_MODAL';
export const HORD_SUPPORTED_TOKENS_MODAL = 'HORD_SUPPORTED_TOKENS_MODAL';
export const GET_WHITELISTED_MODAL = 'GET_WHITELISTED_MODAL';
export const MANUAL_SWAPS_MODAL = 'MANUAL_SWAPS_MODAL';
export const ADD_PROJECT_MODAL = 'ADD_PROJECT_MODAL';
